import React, { useState, useEffect, useRef } from "react";
import Sidebar from '../composant_reutilisable/sidebar';
import Navbar from "../composant_reutilisable/navbar";
import useAuth from "../composant_reutilisable/useAuth";
import { Link, useNavigate } from "react-router-dom";
import { FaSortAmountUp, FaSortAmountDown, FaArrowRight, FaArrowLeft, FaEllipsisV, FaSearch, FaFileExport, FaArchive, FaQuestionCircle, FaChevronUp, FaChevronDown } from "react-icons/fa";
import { BsPerson } from "react-icons/bs";
import { Modal, Button, Spinner, ProgressBar } from "react-bootstrap";
import { ClipboardList } from 'lucide-react';
import Pas_acces from "../composant_reutilisable/pas_acces";
import axios from "axios";
import Footer from "../composant_reutilisable/footer";

const Journalisation = () => {
    useAuth();
    const [isLoading, setIsLoading] = useState(false);
    const user_id = localStorage.getItem('userId');
    const [alert, setAlert] = useState({ message: '', type: '' });
    const navigate = useNavigate();

    const handleItemsPerPageChange = (e) => {
        setItemsPerPage(Number(e.target.value));
        setCurrentPage(1);
    };

    // États
    const [listeActivites, setListeActivites] = useState([]);
    const [totalItems, setTotalItems] = useState(0);
    const [sortConfig, setSortConfig] = useState({ key: 'date', direction: 'descending' });
    const [searchTerm, setSearchTerm] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [openDropdownId, setOpenDropdownId] = useState(null);
    const [selectedActivite, setSelectedActivite] = useState(null);
    const [showModal, setShowModal] = useState(false);

    const [showInfo, setShowInfo] = useState(false);

    const dropdownRef = useRef(null);

    // Fermer le dropdown quand on clique ailleurs
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setOpenDropdownId(null);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    useEffect(() => {
        if (user_id) {
            document.title = "Transportpro | Journal des activités";
        }
    }, [user_id]);

    const showAlert = (message, type = 'success') => {
        setAlert({ message, type });
        setTimeout(() => {
            setAlert({ message: '', type: '' });
        }, 5000);
    };

    // Récupérer la liste des activités avec pagination
    const fetchActivites = async () => {
        try {
            setIsLoading(true);
            const response = await fetch(
                `${process.env.REACT_APP_HOTE}/liste-activites/?page=${currentPage}&per_page=${itemsPerPage}`
            );
            if (response.ok) {
                const data = await response.json();
                setListeActivites(data.data);
                setTotalItems(data.total);
            }
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
            console.error("Erreur lors de la récupération des activités:", error);
        }
    };

    useEffect(() => {
        fetchActivites();
    }, [currentPage, itemsPerPage]);

    // Fonction de tri côté client (si nécessaire)
    const handleSort = (key) => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }
        setSortConfig({ key, direction });
    };

    // Filtrer les activités côté client (si nécessaire)
    const activitesFiltrees = listeActivites.filter(activite =>
        (activite.utilisateur && activite.utilisateur.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (activite.action && activite.action.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (activite.date && activite.date.toLowerCase().includes(searchTerm.toLowerCase()))
    );

    // Pagination
    const totalPages = Math.ceil(totalItems / itemsPerPage);

    // Toggle dropdown
    const toggleDropdown = (id) => {
        setOpenDropdownId(openDropdownId === id ? null : id);
    };

    // Style pour les items du dropdown
    const dropdownItemStyle = {
        padding: '8px 16px',
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
        width: '100%',
        border: 'none',
        background: 'none',
        textAlign: 'left'
    };

    // Afficher les détails dans le modal
    const handleShowDetails = (activite) => {
        setSelectedActivite(activite);
        setShowModal(true);
        setOpenDropdownId(null);
    };

    // Formater les données pour l'affichage dans le modal
    const formatDonneesForModal = (donnees) => {
        try {
            if (typeof donnees === 'object') return donnees;
            const parsed = JSON.parse(donnees.replace(/'/g, '"'));
            return parsed;
        } catch (e) {
            return { error: "Impossible de parser les données", raw: donnees };
        }
    };

    const [showExportModal, setShowExportModal] = useState(false);
    const [isLoadingBouton, setIsLoadingBouton] = useState(false);


    const handleExport = async () => {
        setIsLoadingBouton(true);
        try {
            const url = `${process.env.REACT_APP_HOTE}/export-journalisation/${user_id}/`;

            const response = await fetch(url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/csv",
                },
            });

            if (!response.ok) {
                throw new Error("Erreur lors de l'export des activités de la journalisation");
            }

            // Téléchargement du fichier
            const blob = await response.blob();
            const downloadUrl = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = downloadUrl;
            a.download = "journalisation_export.csv";
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(downloadUrl);

            setShowExportModal(false);
            showAlert("Exportation des activités de la journalisation terminée avec succès !");
            fetchActivites()
        } catch (error) {
            console.error("Erreur d'export:", error);
            showAlert("Une erreur est survenue lors de l'export des activités de la journalisation.", 'danger');
            setShowExportModal(false)
        } finally {
            setIsLoadingBouton(false);
        }
    };

    const [accesGroupes, setAccesGroupes] = useState([]);
    const [groupeId, setGroupeId] = useState(null);
    const groupe = localStorage.getItem('groupe_id');

    const verifGroupe = async () => {
        const groupeStored = localStorage.getItem('groupe_id');
        const accesGroupeStored = localStorage.getItem('accesGroupe');

        if (groupeStored && accesGroupeStored) {
            setGroupeId(groupeStored);
            setAccesGroupes(JSON.parse(accesGroupeStored));
        } else {
            try {
                const response = await axios.get(`${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}`);
                if (response.status === 200) {
                    const data = response.data;
                    setGroupeId(data.groupe);

                    let cleanedAccessArray = [];
                    if (Array.isArray(data.acces)) {
                        cleanedAccessArray = data.acces.map((item) =>
                            item.acces
                                ? item.acces.replace(/[\[\]']/g, '').trim().split(',').map((access) => access.trim())
                                : []
                        ).flat();

                        setAccesGroupes(cleanedAccessArray);
                    }

                    localStorage.setItem('groupe', data.groupe);
                    localStorage.setItem('accesGroupe', JSON.stringify(cleanedAccessArray));
                }
            } catch (error) {
                // console.error('Erreur lors de la vérification du groupe', error);
            }
        }
    };

    useEffect(() => {
        if (user_id) {
            verifGroupe();
        }
    }, [user_id]);

    if (!accesGroupes.includes("Journalisation")) {
        return (
            <Pas_acces />
        );
    }


    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <h2 className="d-flex justify-content-between align-items-center">
                                <div className="d-flex align-items-center">
                                    {/* <BsPerson size={25} className='mr-2' />Journal des activités */}
                                    <ClipboardList size={25} className='mr-2' />Journalisation
                                    {/* <span
                                        className="ml-3 toggle-icon"
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => setShowInfo(!showInfo)}
                                    >
                                        {showInfo ? <FaChevronUp /> : <FaChevronDown />}
                                    </span> */}
                                </div>

                                {/* Bouton d'aide complètement à droite */}
                                {/* <button
                                    className="btn btn-link p-0 ml-2"
                                    title="Manuel d'utilisation"
                                    onClick={() => navigate('/Manuel-utilisation-admin', {
                                        state: {
                                            fromModule: 'administration',
                                            fromSection: 'admin-journalisation'
                                        }
                                    })}
                                >
                                    <FaQuestionCircle size={18} />
                                </button> */}
                            </h2>
                            <small>Historique des actions des utilisateurs.</small>

                            <small id='hbreadcrumb' className='d-flex justify-content-end'>
                                <ol className="breadcrumb custom-breadcrumb">
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/Menu`}> Accueil</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/Admin`}> Administration</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item active">
                                        Journalisation
                                    </li>
                                </ol>
                            </small>
                        </div>
                    </div>

                    {alert.message && (
                        <div className={`mt-3 alert alert-${alert.type}`}>
                            {alert.message}
                        </div>
                    )}
                    <div className="wrapper wrapper-content animated fadeInRight mt-3">
                        <div className="">
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <h5>Liste des activités</h5>
                                <div className="text-right">
                                    <button className="btn btn-success d-flex align-items-center justify-content-center" onClick={() => setShowExportModal(true)}>
                                        <FaArchive />
                                        <span className="d-none d-sm-inline ml-2">Archiver</span>
                                    </button>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="ibox">
                                        <div className="ibox-content">
                                            <div className="table-responsive">
                                                <div className="d-flex justify-content-between align-items-center mb-3">
                                                    <div className="me-2">
                                                        <select
                                                            value={itemsPerPage}
                                                            onChange={handleItemsPerPageChange}
                                                            className="form-select bg-default p-1"
                                                            style={{
                                                                width: "auto",
                                                                border: "1px black solid",
                                                                borderRadius: "5px",
                                                            }}
                                                        >
                                                            <option value={10}>10</option>
                                                            <option value={20}>20</option>
                                                            <option value={50}>50</option>
                                                        </select>
                                                    </div>
                                                    <input
                                                        type="text"
                                                        placeholder="Rechercher..."
                                                        className="form-control"
                                                        style={{ maxWidth: "150px", width: "100%" }}
                                                        value={searchTerm}
                                                        onChange={(e) => setSearchTerm(e.target.value)}
                                                    />
                                                </div>
                                                <table
                                                    className="footable table table-stripped footable-loaded tablet breakpoint"
                                                    data-page-size="8"
                                                    data-filter="#filter"
                                                >
                                                    <thead>
                                                        <tr>
                                                            <th
                                                                className="text-secondary text-wrap d-none d-md-table-cell text-justify"
                                                                onClick={() => handleSort("utilisateur")}
                                                            >
                                                                Utilisateur
                                                                {sortConfig.key === "utilisateur"}{
                                                                    sortConfig.direction === "descending"
                                                                        ? <FaSortAmountUp />
                                                                        : <FaSortAmountDown />
                                                                }
                                                            </th>
                                                            <th
                                                                className="text-secondary text-wrap d-none d-md-table-cell"
                                                                onClick={() => handleSort("action")}
                                                            >
                                                                Action
                                                                {sortConfig.key === "action"}{
                                                                    sortConfig.direction === "descending"
                                                                        ? <FaSortAmountUp />
                                                                        : <FaSortAmountDown />
                                                                }
                                                            </th>
                                                            <th
                                                                className="text-secondary text-wrap d-none d-md-table-cell text-center"
                                                                onClick={() => handleSort("date")}
                                                            >
                                                                Date
                                                                {sortConfig.key === "date"}{
                                                                    sortConfig.direction === "descending"
                                                                        ? <FaSortAmountUp />
                                                                        : <FaSortAmountDown />
                                                                }
                                                            </th>
                                                            {/* <th className="text-secondary text-wrap d-none d-md-table-cell text-justify">
                                                                Détails
                                                            </th> */}
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {isLoading ? (
                                                            <tr>
                                                                <td colSpan="5" className="text-center">
                                                                    <Spinner animation="border" size="sm" /> Chargement des données...
                                                                </td>
                                                            </tr>
                                                        ) : activitesFiltrees.length > 0 ? (
                                                            activitesFiltrees.map((activite) => (
                                                                <tr key={activite.id}>
                                                                    <td className="d-none d-md-table-cell text-justify">
                                                                        {activite.utilisateur || 'N/A'}
                                                                    </td>
                                                                    <td className="d-none d-md-table-cell">
                                                                        {activite.action || 'N/A'}
                                                                    </td>
                                                                    <td className="d-none d-md-table-cell text-center">
                                                                        {activite.date || 'N/A'}
                                                                    </td>
                                                                    {/* <td style={{ textAlign: 'left' }} className="d-none d-md-table-cell">
                                                                        <button
                                                                            className="btn btn-sm d-flex align-items-center"
                                                                            onClick={(e) => {
                                                                                e.stopPropagation();
                                                                                toggleDropdown(activite.id);
                                                                            }}
                                                                            style={{
                                                                                padding: '0.25rem 0.5rem',
                                                                                border: '1px solid #ddd',
                                                                                borderRadius: '4px',
                                                                                backgroundColor: '#f8f9fa'
                                                                            }}
                                                                        >
                                                                            <FaEllipsisV className="ms-1" size={12} />
                                                                        </button>

                                                                        {openDropdownId === activite.id && (
                                                                            <div
                                                                                ref={dropdownRef}
                                                                                style={{
                                                                                    position: 'fixed',
                                                                                    zIndex: 1000,
                                                                                    minWidth: '60px',
                                                                                    right: '80px',
                                                                                    backgroundColor: 'white',
                                                                                    border: '1px solid #ddd',
                                                                                    borderRadius: '4px',
                                                                                    boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
                                                                                    maxHeight: '150px',
                                                                                    overflowY: 'auto',
                                                                                    scrollbarWidth: 'thin',
                                                                                    scrollbarColor: '#ddd #f8f9fa',
                                                                                }}
                                                                                className="custom-scrollbar"
                                                                            >
                                                                                <button
                                                                                    style={dropdownItemStyle}
                                                                                    onClick={() => handleShowDetails(activite)}
                                                                                >
                                                                                    <FaSearch className="me-2 text-info" />
                                                                                    Détails
                                                                                </button>
                                                                            </div>
                                                                        )}
                                                                    </td> */}
                                                                </tr>
                                                            ))
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="5" className="text-center text-muted">
                                                                    Aucune activité à afficher
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>

                                            {/* Pagination */}
                                            <div className="d-flex justify-content-between align-items-center mt-3">
                                                <div className="dataTables_info" role="status" aria-live="polite">
                                                    {listeActivites.length === 0
                                                        ? "Aucun élément à afficher"
                                                        : `Élément ${(currentPage - 1) * itemsPerPage + 1} à ${Math.min(
                                                            currentPage * itemsPerPage,
                                                            totalItems
                                                        )} sur ${totalItems}`}
                                                </div>
                                                <div>
                                                    <button
                                                        onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                                                        className="btn btn-light mx-1"
                                                        disabled={currentPage === 1}
                                                    >
                                                        <FaArrowLeft />
                                                    </button>

                                                    {(() => {
                                                        const pagesToShow = 5;
                                                        let startPage = Math.max(
                                                            1,
                                                            currentPage - Math.floor(pagesToShow / 2)
                                                        );
                                                        let endPage = Math.min(
                                                            totalPages,
                                                            startPage + pagesToShow - 1
                                                        );

                                                        if (endPage - startPage < pagesToShow - 1) {
                                                            startPage = Math.max(
                                                                1,
                                                                endPage - pagesToShow + 1
                                                            );
                                                        }

                                                        const pageButtons = [];

                                                        for (let i = startPage; i <= endPage; i++) {
                                                            pageButtons.push(
                                                                <button
                                                                    key={i}
                                                                    onClick={() => setCurrentPage(i)}
                                                                    className={`btn ${currentPage === i
                                                                        ? "btn-default"
                                                                        : "btn-light"
                                                                        } mx-1`}
                                                                >
                                                                    {i}
                                                                </button>
                                                            );
                                                        }

                                                        return pageButtons;
                                                    })()}

                                                    <button
                                                        onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                                                        className="btn btn-light mx-1"
                                                        disabled={currentPage === totalPages}
                                                    >
                                                        <FaArrowRight />
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="footer text-center">
                        <Footer />
                    </div>
                </div>
            </div>

            {/* Modal pour afficher les détails */}
            <Modal show={showModal} onHide={() => setShowModal(false)} size="lg">
                <Modal.Header>
                    <Modal.Title>Détails de l'activité</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {selectedActivite && (
                        <div>
                            <div className="mb-3">
                                <h6>Données</h6>
                                <pre style={{
                                    whiteSpace: 'pre-wrap',
                                    wordWrap: 'break-word',
                                    backgroundColor: '#f8f9fa',
                                    padding: '10px',
                                    borderRadius: '5px'
                                }}>
                                    {JSON.stringify(formatDonneesForModal(selectedActivite.donnees), null, 2)}
                                </pre>
                            </div>
                        </div>
                    )}
                    {/* {selectedActivite && (
                        <div>
                            <div className="mb-4">
                                <h5>Résumé de l'action</h5>
                                <div className="card p-3 bg-light">
                                    <div className="row">
                                        <div className="col-md-4">
                                            <p><strong>Utilisateur :</strong> {selectedActivite.utilisateur}</p>
                                        </div>
                                        <div className="col-md-4">
                                            <p><strong>Action :</strong> {selectedActivite.action}</p>
                                        </div>
                                        <div className="col-md-4">
                                            <p><strong>Date :</strong> {new Date(selectedActivite.date).toLocaleString('fr-FR')}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="mb-4">
                                <h5>Détails de l'action</h5>
                                {(() => {
                                    try {
                                        const donnees = formatDonneesForModal(selectedActivite.donnees);

                                        // Cas particulier pour les modifications de camion
                                        if (selectedActivite.action.includes('Modification du camion')) {
                                            return (
                                                <div className="card">
                                                    <div className="card-body">
                                                        <div className="row">
                                                            <div className="col-md-6">
                                                                <h6 className="text-danger">Avant modification</h6>
                                                                <div className="card">
                                                                    <div className="card-body">
                                                                        <p><strong>Statut :</strong> {donnees.avant?.statut}</p>
                                                                        <p><strong>Ordre :</strong> {donnees.avant?.ordre}</p>
                                                                        <p><strong>Conducteur :</strong> {donnees.avant?.conducteur}</p>
                                                                        <p><strong>Genre :</strong> {donnees.avant?.genre}</p>
                                                                        <p><strong>Type camion :</strong> {donnees.avant?.type_camion}</p>
                                                                        <p><strong>Appartenance :</strong> {Array.isArray(donnees.avant?.appartenance)
                                                                            ? donnees.avant.appartenance.join(', ')
                                                                            : donnees.avant?.appartenance}</p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <h6 className="text-success">Après modification</h6>
                                                                <div className="card">
                                                                    <div className="card-body">
                                                                        <p><strong>Statut :</strong> {donnees.après?.statut}</p>
                                                                        <p><strong>Ordre :</strong> {donnees.après?.ordre}</p>
                                                                        <p><strong>Conducteur :</strong> {donnees.après?.conducteur}</p>
                                                                        <p><strong>Genre :</strong> {donnees.après?.genre}</p>
                                                                        <p><strong>Type camion :</strong> {donnees.après?.type_camion}</p>
                                                                        <p><strong>Appartenance :</strong> {Array.isArray(donnees.après?.appartenance)
                                                                            ? donnees.après.appartenance.join(', ')
                                                                            : donnees.après?.appartenance}</p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="row mt-3">
                                                            <div className="col-md-12">
                                                                <h6>Autres informations</h6>
                                                                <div className="card">
                                                                    <div className="card-body">
                                                                        <div className="row">
                                                                            <div className="col-md-4">
                                                                                <p><strong>Charge utile :</strong> {donnees.avant?.charge_utile}</p>
                                                                            </div>
                                                                            <div className="col-md-4">
                                                                                <p><strong>Numéro permis :</strong> {donnees.avant?.numero_permis}</p>
                                                                            </div>
                                                                            <div className="col-md-4">
                                                                                <p><strong>Catégorie permis :</strong> {donnees.avant?.categorie_permis}</p>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        }

                                        // Cas particulier pour les ajouts de camion
                                        if (selectedActivite.action.includes('Ajout')) {
                                            return (
                                                <div className="card">
                                                    <div className="card-body">
                                                        <h6>Détails du camion ajouté</h6>
                                                        <div className="row">
                                                            <div className="col-md-6">
                                                                <p><strong>Statut :</strong> {donnees.statut}</p>
                                                                <p><strong>Conducteur :</strong> {donnees.conducteur}</p>
                                                                <p><strong>Genre :</strong> {donnees.genre}</p>
                                                                <p><strong>Type camion :</strong> {donnees.type_camion}</p>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <p><strong>Appartenance :</strong> {Array.isArray(donnees.appartenance)
                                                                    ? donnees.appartenance.join(', ')
                                                                    : donnees.appartenance}</p>
                                                                <p><strong>Charge utile :</strong> {donnees.charge_utile}</p>
                                                                <p><strong>Numéro permis :</strong> {donnees.numero_permis}</p>
                                                                <p><strong>Catégorie permis :</strong> {donnees.categorie_permis}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        }

                                        // Cas particulier pour les réservations de transport
                                        if (selectedActivite.action.includes('Réservation de transport')) {
                                            return (
                                                <div className="card">
                                                    <div className="card-body">
                                                        <h6>Informations sur la réservation</h6>
                                                        <div className="row">
                                                            <div className="col-md-4">
                                                                <p><strong>Référence fret :</strong> {donnees.ref}</p>
                                                                <p><strong>Charge utile totale :</strong> {donnees.charge_utile_totale}</p>
                                                            </div>
                                                            <div className="col-md-8">
                                                                <h6>Types de camions réservés</h6>
                                                                <div className="row">
                                                                    {donnees.types_camions?.map((typeId, index) => (
                                                                        <div key={`type-${index}`} className="col-md-6 mb-2">
                                                                            <div className="card">
                                                                                <div className="card-body">
                                                                                    <p><strong>Type camion ID :</strong> {typeId}</p>
                                                                                    <p><strong>Nombre :</strong> {donnees.nbre_type?.[typeId] || 0}</p>
                                                                                    <p><strong>Charge utile par camion :</strong> {donnees.charge_utile_par_type?.[typeId] || 0}</p>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        }

                                        // Cas particulier pour les assignations de camions
                                        if (selectedActivite.action.includes('Assignation de camions')) {
                                            return (
                                                <div className="card">
                                                    <div className="card-body">
                                                        <h6>Résumé de l'assignation</h6>
                                                        <div className="row">
                                                            <div className="col-md-6">
                                                                <p><strong>Référence fret :</strong> {donnees.ref}</p>
                                                                <p><strong>Bailleur :</strong> {donnees.bailleur}</p>
                                                                <p><strong>Statut fret :</strong> {donnees.statut_fret}</p>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <p><strong>Camions assignés :</strong> {donnees.total_assignes}/{donnees.total_camions_fret}</p>
                                                            </div>
                                                        </div>

                                                        <h6 className="mt-3">Quotas restants</h6>
                                                        <div className="row">
                                                            <div className="col-md-4">
                                                                <div className="card">
                                                                    <div className="card-header bg-primary text-white">
                                                                        Nationaux
                                                                    </div>
                                                                    <div className="card-body">
                                                                        <ul className="list-group">
                                                                            {donnees.quotas_restants?.nationaux && Object.entries(donnees.quotas_restants.nationaux).map(([type, qty]) => (
                                                                                <li key={`national-${type}`} className="list-group-item d-flex justify-content-between">
                                                                                    {type}
                                                                                    <span className="badge bg-primary">{qty}</span>
                                                                                </li>
                                                                            ))}
                                                                        </ul>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-4">
                                                                <div className="card">
                                                                    <div className="card-header bg-success text-white">
                                                                        Internationaux
                                                                    </div>
                                                                    <div className="card-body">
                                                                        <ul className="list-group">
                                                                            {donnees.quotas_restants?.pays_destination && Object.entries(donnees.quotas_restants.pays_destination).map(([type, qty]) => (
                                                                                <li key={`pays-${type}`} className="list-group-item d-flex justify-content-between">
                                                                                    {type}
                                                                                    <span className="badge bg-success">{qty}</span>
                                                                                </li>
                                                                            ))}
                                                                        </ul>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-4">
                                                                <div className="card">
                                                                    <div className="card-header bg-warning text-dark">
                                                                        Bailleur
                                                                    </div>
                                                                    <div className="card-body">
                                                                        <ul className="list-group">
                                                                            {donnees.quotas_restants?.bailleur && Object.entries(donnees.quotas_restants.bailleur).map(([type, qty]) => (
                                                                                <li key={`bailleur-${type}`} className="list-group-item d-flex justify-content-between">
                                                                                    {type}
                                                                                    <span className="badge bg-warning text-dark">{qty}</span>
                                                                                </li>
                                                                            ))}
                                                                        </ul>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        }

                                        // Affichage générique si aucun cas particulier n'est détecté
                                        return (
                                            <div className="card">
                                                <div className="card-body">
                                                    <ul className="list-group">
                                                        {Object.entries(donnees).map(([key, value]) => (
                                                            <li key={key} className="list-group-item">
                                                                <strong>{key.replace(/_/g, ' ')}:</strong> {JSON.stringify(value)}
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </div>
                                            </div>
                                        );

                                    } catch (e) {
                                        return (
                                            <div className="alert alert-warning">
                                                Impossible d'afficher les détails de manière structurée. Voici le contenu brut :
                                                <pre className="mt-2">{selectedActivite.donnees}</pre>
                                            </div>
                                        );
                                    }
                                })()}
                            </div>
                        </div>
                    )} */}
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-secondary" onClick={() => setShowModal(false)}>
                        Fermer
                    </button>
                </Modal.Footer>
            </Modal>

            <Modal show={showExportModal} onHide={() => setShowExportModal(false)}>
                <Modal.Header>
                    <Modal.Title>Exporter les conducteurs</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Voulez-vous exporter l'ensemble des conducteurs au format CSV ?</p>
                    {/* <p className="text-muted">Le fichier contiendra tous les nom_conducteur et leurs définitions.</p> */}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowExportModal(false)} disabled={isLoading}>
                        Annuler
                    </Button>
                    <Button variant="success" onClick={handleExport} disabled={isLoading}>
                        {isLoadingBouton ? (
                            <>
                                {/* <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> */}
                                <span className="ms-2">Export en cours...</span>
                            </>
                        ) : (
                            "Exporter"
                        )}
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default Journalisation;